import * as React from 'react'

import PayoutTextExcludingLastDay from './payoutTextExcludingLastDay'
import PayoutTextFallBack from './payoutTextFallBack'
import PayoutTextForLastDay from './payoutTextForLastDay'

interface PayoutTextProps {
  pendingDays: string | number
  commissionType: string
  brandCommission: string | number
}

const PayoutText: React.FC<PayoutTextProps> = ({
  pendingDays,
  commissionType,
  brandCommission,
}) => {
  if (Number(pendingDays) > 1) {
    return (
      <PayoutTextExcludingLastDay
        brandCommission={brandCommission}
        commissionType={commissionType}
        pendingDays={pendingDays}
      />
    )
  } else if (Number(pendingDays) === 1) {
    return (
      <PayoutTextForLastDay
        brandCommission={brandCommission}
        commissionType={commissionType}
      />
    )
  } else {
    return (
      <PayoutTextFallBack
        brandCommission={brandCommission}
        commissionType={commissionType}
      />
    )
  }
}

export default PayoutText
